/**
 * All buttons based on theme are available here.
 *
 * @remarks
 * Styles are brought in from Figma
 */

import { Button, chakra, IconButton } from "@chakra-ui/react";

const PrimaryButton = chakra(Button, {
  baseStyle: {
    backgroundColor: "yellow.500",
    color: "white",
    _hover: { backgroundColor: "hjsPrimaryHover" },
    _active: {
      boxShadow: "inset 2px 4px 22px rgba(0, 0, 0, 0.25) !important",
    },
  },
});
const SecondaryButton = chakra(Button, {
  baseStyle: {
    backgroundColor: "teal.600",
    color: "white",
    _hover: { backgroundColor: "hjsSecondaryHover" },
    _focus: { backgroundColor: "hjsSecondaryHover" },
    _active: {
      backgroundColor: "teal.600",
      boxShadow: "inset 2px 4px 22px rgba(0, 0, 0, 0.25) !important",
    },
  },
});
const OutlineButton = chakra(Button, {
  baseStyle: {
    variant: "outline",
    border: "2px",
    color: "teal.700",
    backgroundColor: "blackAlpha.50",
    borderColor: "teal.700",
    _hover: { backgroundColor: "white" },
    _active: {
      boxShadow: "inset 2px 4px 22px rgba(0, 0, 0, 0.25) !important",
    },
  },
});
const PrimaryIconButton = chakra(IconButton, {
  baseStyle: {
    backgroundColor: "yellow.500",
    color: "white",
    _hover: { backgroundColor: "hjsPrimaryHover" },
    _active: {
      boxShadow: "inset 2px 4px 22px rgba(0, 0, 0, 0.25) !important",
    },
  },
});
const SecondaryIconButton = chakra(IconButton, {
  baseStyle: {
    backgroundColor: "teal.600",
    color: "white",
    _hover: { backgroundColor: "hjsSecondaryHover" },
    _active: {
      boxShadow: "inset 2px 4px 22px rgba(0, 0, 0, 0.25) !important",
    },
  },
});
export {
  PrimaryButton,
  SecondaryButton,
  OutlineButton,
  PrimaryIconButton,
  SecondaryIconButton,
};
